import { httpClient } from '../httpClient';

export const evidenceMethods = {
  // ── Evidence (US10) ────────────────────────────────────────────
  listEvidence: (assessmentId, params) =>
    httpClient.get(`/pdpl/assessment/${assessmentId}/evidence`, { params }),

  uploadEvidence: (assessmentId, data) =>
    httpClient.post(`/pdpl/assessment/${assessmentId}/evidence`, data),

  deleteEvidence: (evidenceId) =>
    httpClient.delete(`/pdpl/evidence/${evidenceId}`),

  getEvidence: (evidenceId) =>
    httpClient.get(`/pdpl/evidence/${evidenceId}`),

  updateEvidence: (evidenceId, data) =>
    httpClient.patch(`/pdpl/evidence/${evidenceId}`, data),

  linkEvidence: (sourceId, data) =>
    httpClient.post(`/pdpl/evidence/${sourceId}/link`, data),

  approveArticleLink: (evidenceId, articleRef) =>
    httpClient.post(
      `/pdpl/evidence/${evidenceId}/article-links/${encodeURIComponent(articleRef)}/approve`,
    ),

  // ── Evidence v2 (spec evidence_feature §4.2 — Phase 2/3) ─────────
  getScoreBreakdown: (assessmentId) =>
    httpClient.get(`/pdpl/assessment/${assessmentId}/score-breakdown`),

  getArticlesEvidence: (assessmentId) =>
    httpClient.get(`/pdpl/assessment/${assessmentId}/articles-evidence`),

  getEvidenceSuggestions: (assessmentId, params) =>
    httpClient.get(`/pdpl/assessment/${assessmentId}/evidence/suggestions`, { params }),

  uploadEvidenceVersion: (evidenceId, data) =>
    httpClient.post(`/pdpl/evidence/${evidenceId}/versions`, data),

  listEvidenceVersions: (evidenceId, params) =>
    httpClient.get(`/pdpl/evidence/${evidenceId}/versions`, { params }),

  listVersionReviews: (params) =>
    httpClient.get('/pdpl/evidence/version-reviews', { params }),

  decideVersionReview: (reviewId, data) =>
    httpClient.patch(`/pdpl/evidence/version-reviews/${reviewId}`, data),

  batchUpgradeVersions: (evidenceId, data) =>
    httpClient.post(`/pdpl/evidence/${evidenceId}/versions/batch-upgrade`, data),

  getEvidenceAccessLog: (evidenceId, params) =>
    httpClient.get(`/pdpl/evidence/${evidenceId}/access-log`, { params }),
};
